import { createSelector } from 'reselect'

export const getBuyCartNotification = createSelector(
  (state) => state && state.cart && state.cart.buyCartNotification,
  buyCartNotification => buyCartNotification
)
